import { createFileRoute, redirect } from '@tanstack/react-router'
import useLoginStore from '@/store/LoginStore'
import { isAuthenticated } from '@/lib/auth/authSession'

export const Route = createFileRoute('/')({
  beforeLoad: ({ location }) => {
    const { workspaceSlug } = useLoginStore.getState()

    // Post-sign-in resolver (/callback) or onboarding: don't redirect
    if (location.pathname === '/callback' || location.pathname === '/onboarding') {
      return
    }

    // If authenticated and has workspace, go to workspace
    if (isAuthenticated() && workspaceSlug) {
      throw redirect({ to: '/$workspaceSlug', params: { workspaceSlug } })
    }

    // Signed in but no workspace in the store yet: /callback looks it up
    if (isAuthenticated()) {
      throw redirect({ to: '/callback' })
    }

    // Not authenticated, show auth page to choose sign in or create account
    throw redirect({ to: '/auth' })
  },
  component: () => null,
})
